(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('recently-viewed-products')) {
    class RecentlyViewedProducts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.items = this.querySelector('[data-recently-viewed-items]');

        const handles = this.readHandles();
        const currentHandle = this.dataset.productHandle;
        const limit = Number.parseInt(this.dataset.limit, 10) || 4;
        const handlesToRender = handles
          .filter((handle) => handle !== currentHandle);

        if (currentHandle) this.storeHandle(currentHandle, handles);
        if (handlesToRender.length) this.renderProducts(handlesToRender, limit);
      }

      readHandles() {
        try {
          const handles = JSON.parse(localStorage.getItem(this.dataset.storageKey) || '[]');
          return Array.isArray(handles)
            ? handles.filter((handle) => typeof handle === 'string' && handle.length)
            : [];
        } catch (error) {
          return [];
        }
      }

      storeHandle(currentHandle, handles) {
        try {
          const updatedHandles = [currentHandle]
            .concat(handles.filter((handle) => handle !== currentHandle))
            .slice(0, 20);
          localStorage.setItem(this.dataset.storageKey, JSON.stringify(updatedHandles));
        } catch (error) {
          return;
        }
      }

      async renderProducts(handles, limit) {
        const cards = [];

        for (let index = 0; index < handles.length && cards.length < limit; index += limit) {
          const batch = handles.slice(index, index + limit);
          const batchCards = await Promise.all(batch.map((handle) => this.fetchCard(handle)));
          cards.push(...batchCards.filter(Boolean));
        }

        cards.slice(0, limit).forEach((card) => this.items.appendChild(card));
        if (!this.items.children.length) return;

        this.activateProductData();
        this.initializeProductCards();
        this.hidden = false;
        this.initializeSlider();
        this.dispatchEvent(new CustomEvent('recently-viewed:loaded', { bubbles: true }));
      }

      async fetchCard(handle) {
        const url = `${this.dataset.productsRoot}${encodeURIComponent(handle)}?section_id=${encodeURIComponent(this.dataset.renderSectionId)}`;

        try {
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) return null;

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const template = documentFragment.querySelector('template[data-recently-viewed-card]');
          if (!template || !template.content.querySelector('[data-recently-viewed-handle]')) return null;

          return document.importNode(template.content, true);
        } catch (error) {
          return null;
        }
      }

      activateProductData() {
        this.items.querySelectorAll('script[data-product-data]').forEach((oldScript) => {
          const newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach((attribute) => {
            newScript.setAttribute(attribute.name, attribute.value);
          });
          newScript.textContent = oldScript.textContent;
          oldScript.replaceWith(newScript);
        });
      }

      initializeProductCards() {
        if (typeof window.displayPricesAndColors !== 'function') return;

        this.items.querySelectorAll('.home-grid-item-inner').forEach((card) => {
          window.displayPricesAndColors.call(card, {});
        });
      }

      initializeSlider() {
        const $ = window.jQuery;
        if (typeof $ !== 'function' || typeof $.fn.slick !== 'function') return;

        const $items = $(this.items);
        if ($items.hasClass('slick-initialized')) return;

        const width = $(window).width();
        if (width < 1024) {
          // Below 1024px, skip slick entirely — the CSS falls back to a
          // native horizontally-scrolling row (overflow-x: auto) instead,
          // sidestepping slick's mobile quirks altogether.
          return;
        }

        // slick's `responsive` option (breakpoint-switching at runtime) is
        // unreliable combined with `infinite:true` (needed below to avoid a
        // blank trailing page) — compute the tier once from the actual
        // width instead of trusting slick to swap it live. Matches the
        // tiering used for the similar-items slider (detail.js.liquid).
        const slidesPerView = width < 1400 ? 4 : 5;
        const itemCount = this.items.children.length;

        // Keep a normal four-column flex row when every requested product
        // already fits. Slick is only needed when there are additional cards
        // to navigate to.
        if (itemCount <= slidesPerView) return;

        $items.slick({
          dots: false,
          arrows: true,
          infinite: true,
          speed: 300,
          slidesToShow: slidesPerView,
          slidesToScroll: Math.min(slidesPerView, itemCount)
        });
      }
    }

    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }

  } catch(e) { console.error(e); }
})();
})();
